import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _headingVariantStyles;

import { css } from 'styled-components';
import { typographyDisplay1, typographyDisplay2, typographyDisplay3, typographyHeading1, typographyHeading2, typographySubtitle1, typographySubtitle2, typographySubtitle3 } from "../../core";
import { HEADING_TYPES } from "../constants";
export var headingVariantStyles = (_headingVariantStyles = {}, _defineProperty(_headingVariantStyles, HEADING_TYPES.DISPLAY_1, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref) {
  var theme = _ref.theme;
  return typographyDisplay1(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.DISPLAY_2, css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return typographyDisplay2(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.DISPLAY_3, css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref3) {
  var theme = _ref3.theme;
  return typographyDisplay3(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.HEADING_1, css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return typographyHeading1(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.HEADING_2, css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref5) {
  var theme = _ref5.theme;
  return typographyHeading2(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.SUBTITLE_1, css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref6) {
  var theme = _ref6.theme;
  return typographySubtitle1(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.SUBTITLE_2, css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref7) {
  var theme = _ref7.theme;
  return typographySubtitle2(theme);
})), _defineProperty(_headingVariantStyles, HEADING_TYPES.SUBTITLE_3, css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref8) {
  var theme = _ref8.theme;
  return typographySubtitle3(theme);
})), _headingVariantStyles);